import cx from 'classnames';
import React, { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import RedditConnectModal from 'components/RedditConnectModal';
import Spinner from 'components/Spinner';
import s from './ServerPage.module.scss';
import useGetInfo from '../../hooks/useGetInfo';
import { Banners } from '../../components/NewsTickerBanner/Banners';
import { SideMenu } from '../../components/SideMenu/SideMenu';

interface ServerPageInterface {
  visible?: boolean;
}

export const ServerPage: React.FC<ServerPageInterface> = ({
  visible = true,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const { community: activeCommunity, communityNotLoaded } = useGetInfo();
  // const [errorMessage, setErrorMessage] = useState<string | undefined>(
  //   undefined,
  // );

  const location = useLocation();
  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTo(0, 0);
    }
  }, [contentRef, location.pathname]);

  // Login-time TGR capacity check (commented out by request)
  // useEffect(() => {
  //   if (activeCommunity?.pk) {
  //     getBackgroundCheckStatus(activeCommunity.pk)
  //       .then((result) => {
  //         if (!result.allowed) {
  //           const t = platform === 'discord' ? 'TGR' : 'TGA';
  //           setErrorMessage(
  //             `Connect with us and we’ll tailor your ${t} capacity to your community’s needs.`,
  //           );
  //         }
  //       })
  //       .catch((error) => {
  //         console.error(error.message);
  //       });
  //   }
  // }, [activeCommunity]);

  if (!communityNotLoaded) return <Spinner fullPage />;

  return (
    <main className={s.root}>
      <div className={cx(s.main, !visible && s.hidden)}>
        <RedditConnectModal />
        <SideMenu />
      </div>
      <div className={s.content} ref={contentRef}>
        <Banners />
        {/* {showSupportModal && (
          <SupportModal close={() => setShowSupportModal(false)} />
        )}
       */}

        {/* {errorMessage && (
          <UpgradePlanModal
            title={`You’re ready for more! 🎉`}
            message={errorMessage}
            handleClose={() => {
              setErrorMessage(undefined);
            }}
            handleSubmit={() => {
              setErrorMessage(undefined);
              setShowSupportModal(true);
            }}
            primaryButtonText="Contact Us"
          ></UpgradePlanModal>
        )} */}
        <Outlet />
      </div>
    </main>
  );
};
